import React from 'react';
import LocationTemplate from './LocationTemplate';

const AhoskiePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Ahoskie"
      stateName="North Carolina"
      countyName="Hertford"
      zipCodes={["27910"]}
      latitude={36.2862}
      longitude={-76.9844}
      population={4523}
      historicalFact="Founded in 1893, named after the Ahoskie Creek; known as the 'Only One' due to its unique name."
      nearbyTowns={[
        "Murfreesboro, NC",
        "Winton, NC",
        "Aulander, NC",
        "Rich Square, NC",
        "Powellsville, NC",
        "Colerain, NC",
        "Gatesville, NC",
        "Elizabeth City, NC"
      ]}
    />
  );
};

export default AhoskiePage;